import { __read, __values } from "tslib";
import { HubTileID } from '@office-start/appbar-types';
var hubTileIdMap = new Map([
    ["ShellMail" /* FirstPartyWorkloadIds.Outlook */, HubTileID.outlook],
    ["ShellDocuments" /* FirstPartyWorkloadIds.OneDrive */, HubTileID.onedrive],
    ["ShellTeams" /* FirstPartyWorkloadIds.TeamsForLife */, HubTileID.teams],
    ["ShellSkypeTeams" /* FirstPartyWorkloadIds.Teams */, HubTileID.teams],
    ["ShellWordOnline" /* FirstPartyWorkloadIds.Word */, HubTileID.word],
    ["ShellExcelOnline" /* FirstPartyWorkloadIds.Excel */, HubTileID.excel],
    ["ShellPowerPointOnline" /* FirstPartyWorkloadIds.PowerPoint */, HubTileID.powerpoint],
    ["ShellOneNoteOnline" /* FirstPartyWorkloadIds.OneNote */, HubTileID.onenote],
    ["ShellSway" /* FirstPartyWorkloadIds.Sway */, HubTileID.sway],
    ["ShellOfficeForms" /* FirstPartyWorkloadIds.Forms */, HubTileID.forms],
    ["ShellVisioOnline" /* FirstPartyWorkloadIds.Visio */, HubTileID.visio],
    ["ShellMicrosoftStream" /* FirstPartyWorkloadIds.Stream */, HubTileID.stream],
    ["ShellToDo" /* FirstPartyWorkloadIds.ToDo */, HubTileID.todo],
    ["ShellFamilySafety" /* FirstPartyWorkloadIds.FamilySafety */, HubTileID.familysafety],
    ["ShellCalendar" /* FirstPartyWorkloadIds.Calendar */, HubTileID.calendar],
    ["ShellSkype" /* FirstPartyWorkloadIds.Skype */, HubTileID.skype],
    ["ShellPeople" /* FirstPartyWorkloadIds.People */, HubTileID.people],
    ["ShellLogicFlows" /* FirstPartyWorkloadIds.Flow */, HubTileID.powerautomate],
    ["ShellClipchamp" /* FirstPartyWorkloadIds.Clipchamp */, HubTileID.clipchamp],
    ["ShellLists" /* FirstPartyWorkloadIds.Lists */, HubTileID.lists],
    ["ShellAdmin" /* FirstPartyWorkloadIds.Admin */, HubTileID.admin],
]);
/**
 * Gets the hub tile id from a first party workload id
 *
 * @param {string} firstPartyWorkloadId The workload id with or without the "Shell" prefix
 * @returns {string | undefined} The hub tile id
 */
export function getHubTileIdFromFirstPartyWorkloadId(firstPartyWorkloadId) {
    if (firstPartyWorkloadId.indexOf('Shell') === -1) {
        // First Party workloads ids from the Apps Module are expected to have ids without the 'Shell' prefix,
        // so add them back for string comparison purposes
        firstPartyWorkloadId = 'Shell' + firstPartyWorkloadId;
    }
    return hubTileIdMap.get(firstPartyWorkloadId);
}
/**
 * Gets the first party workload id from a hub tile id
 *
 * @param {string} hubTileId The hub tile id
 * @param {boolean} isMsa A boolean whether user is MSA or not
 * @returns {string | undefined} The workload id with the "Shell" prefix
 */
export function getFirstPartyWorkloadId(hubTileId, isMsa) {
    var e_1, _a;
    if (hubTileId === HubTileID.teams) {
        return isMsa
            ? "ShellTeams" /* FirstPartyWorkloadIds.TeamsForLife */
            : "ShellSkypeTeams" /* FirstPartyWorkloadIds.Teams */;
    }
    try {
        for (var hubTileIdMap_1 = __values(hubTileIdMap), hubTileIdMap_1_1 = hubTileIdMap_1.next(); !hubTileIdMap_1_1.done; hubTileIdMap_1_1 = hubTileIdMap_1.next()) {
            var _b = __read(hubTileIdMap_1_1.value, 2), workloadId = _b[0], tileID = _b[1];
            if (hubTileId === tileID) {
                return workloadId;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (hubTileIdMap_1_1 && !hubTileIdMap_1_1.done && (_a = hubTileIdMap_1.return)) _a.call(hubTileIdMap_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return;
}
//# sourceMappingURL=getHubTileIdFromFirstPartyWorkloadId.js.map